// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电机学",
      "tec": "韩芳旭王馨苒",
      "week": "1-8周",
      "add": "教学楼D座122新能"
    },
    {
      "sub": "机械设计基础",
      "tec": "鲍君善",
      "week": "1-8周",
      "add": "教学楼C座308教务"
    },
    {
      "sub": "专业英语",
      "tec": "高微",
      "week": "1-8周",
      "add": "教学楼D座121新能"
    },
    {
      "sub": "风力发电原理",
      "tec": "关新",
      "week": "1-12周",
      "add": "教学楼D座121新能"
    },
    0
  ],
  "2": [
    {
      "sub": "太阳能光伏发电系统",
      "tec": "高微",
      "week": "1-12周",
      "add": "教学楼C座302教务"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "国家安全教育",
        "tec": "李芗霓",
        "week": "9-12周",
        "add": "图书馆1楼党史+网络数字教育基地"
      }
    ],
    {
      "sub": "太阳能热利用",
      "tec": "张宏丽",
      "week": "1-8周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "风电场电气系统",
      "tec": "陈琳",
      "week": "1-12周",
      "add": "教学楼D座124新能"
    },
    0
  ],
  "3": [
    {
      "sub": "风力发电原理",
      "tec": "关新",
      "week": "1-12周",
      "add": "教学楼B座322能动"
    },
    {
      "sub": "热工基础",
      "tec": "张霈雯",
      "week": "1-12周",
      "add": "教学楼B座321能动"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "机械设计基础",
      "tec": "鲍君善",
      "week": "1-8周",
      "add": "教学楼C座112教务"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "国家安全教育",
        "tec": "李芗霓",
        "week": "9-12周",
        "add": "图书馆1楼党史+网络数字教育基地"
      }
    ],
    {
      "sub": "电机学",
      "tec": "韩芳旭王馨苒",
      "week": "1-8周",
      "add": "教学楼A座217电力"
    },
    {
      "sub": "太阳能光伏发电系统",
      "tec": "高微",
      "week": "1-12周",
      "add": "教学楼A座126信息"
    },
    {
      "sub": "太阳能照明工程",
      "tec": "于子淞陈琳",
      "week": "5-12周",
      "add": "教学楼C座110教务"
    }
  ],
  "5": [
    {
      "sub": "热工基础",
      "tec": "张霈雯",
      "week": "1-12周",
      "add": "教学楼C座303教务"
    },
    {
      "sub": "工程伦理",
      "tec": "毛云秀王若曦",
      "week": "1-8周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "风电场电气系统",
      "tec": "陈琳",
      "week": "1-12周",
      "add": "教学楼D座120新能"
    },
    {
      "sub": "就业创业指导",
      "tec": "赵明明李瀚林",
      "week": "1-5周",
      "add": "教学楼C座212教务"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
